module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel slider-navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "wr"
    }, [_c('div', {
      staticClass: "topBlock"
    }, [_c('a', {
      staticClass: "imgContainer",
      style: (("background-image: url(" + (item.img) + ")")),
      attrs: {
        "href": item.buttonHref
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "labelContainer"
    }, [(item.newLabel) ? _c('div', {
      staticClass: "newLabel"
    }, [_vm._v(_vm._s(item.newLabel))]) : _vm._e(), _vm._v(" "), (item.recomendedLabel) ? _c('div', {
      staticClass: "recomendedLabel"
    }, [_vm._v(_vm._s(item.recomendedLabel))]) : _vm._e()]), _vm._v(" "), (item.moreColorsImg) ? _c('a', {
      staticClass: "moreColors",
      attrs: {
        "href": item.href
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M24 0H0v24h24z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.moreColorsImg)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "middleBlock"
    }), _vm._v(" "), _c('div', {
      staticClass: "bottomBlock"
    }, [_c('div', {
      staticClass: "infoContainer"
    }, [_c('div', {
      staticClass: "stars"
    }, _vm._l((5), function(star, n) {
      return (item.stars ? item.stars : 1) ? _c('div', {
        class: n < item.stars ? 'star full' : 'star empty'
      }, [_c('svg', {
        attrs: {
          "viewBox": "0 0 18 18",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M0 0h18v18H0z",
          "fill": "none"
        }
      })])]) : _vm._e()
    }), 0), _vm._v(" "), (item.inStock) ? _c('div', {
      staticClass: "inStock"
    }, [_vm._v(_vm._s(item.inStock))]) : _vm._e()]), _vm._v(" "), (item.title) ? _c('a', {
      staticClass: "title",
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.delivery) ? _c('p', {
      staticClass: "delivery"
    }, [_c('svg', {
      staticClass: "feather feather-check-circle",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M22 11.07V12a10 10 0 1 1-5.93-9.14"
      }
    }), _vm._v(" "), _c('polyline', {
      attrs: {
        "points": "23 3 12 14 9 11"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "deliveryText"
    }, [_vm._v(_vm._s(item.delivery))])]) : _vm._e(), _vm._v(" "), (item.moreColorsBottom) ? _c('a', {
      staticClass: "moreColors",
      attrs: {
        "href": item.href
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M24 0H0v24h24z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.moreColorsBottom)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "priceAndBuy"
    }, [_c('div', {
      staticClass: "priceContainer"
    }, [(item.oldPrice) ? _c('p', {
      staticClass: "oldPrice",
      domProps: {
        "innerHTML": _vm._s(item.oldPrice)
      }
    }) : _vm._e(), _vm._v(" "), (item.price) ? _c('p', {
      staticClass: "price",
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    }) : _vm._e()]), _vm._v(" "), (item.buttonText) ? _c('a', {
      staticClass: "yam-button waves-effect waves-light",
      attrs: {
        "href": item.buttonHref
      }
    }, [_vm._v(_vm._s(item.buttonText))]) : _vm._e()])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69753aee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/stock-product.vue
// module id = 254
// module chunks = 35